import * as translate from "../../translations";

let defaultData = translate["en_US"];

const translations = (state = [], action) => {
  let data, lang;

  switch (action.type) {
    case "GET_TRANSLATIONS":
      // lang = Cookies.get('UsrLocale') || 'en_US';
      data = Object.assign(defaultData, state, translate["en_US"]);
      return data;
    case "SET_LANG":
      // lang = Cookies.get('UsrLocale') || 'en_US';
      data = Object.assign(defaultData, state, translate["en_US"]);
      return data;
  }

  return state;
};

export default translations;
